import GlassFrogModel from 'legacy/GlassFrog/GlassFrogModel'

const Circle = GlassFrogModel.extend({}, {
  resourceName: 'circles',
})

export default Circle
